import React, { useState } from "react";
import Input from "../../../../Components/UI/Input";
import { useFormContext } from "react-hook-form";
import { useCheckEmpValidationQuery } from "AppQuries/employee/emp-validation";
import { Eye, EyeOff, Info } from "react-feather";
import { useEmpUserNameValidationMutation } from "AppQuries/employee/add-employee";
const activestatus = [
  { id: true, label: "Yes", value: true },
  { id: false, label: "No", value: false },
];

const userType = [
  { id: true, label: "Employee", value: "Employee" },
  { id: false, label: "HR", value: "HR" },
];

const loginTypeOptions = [
  { label: "QR Login", value: "QRLogin" },
  { label: "Remote Login", value: "RemoteLogin" },
  { label: "Face Login", value: "FaceLogin" },
  { label: "Biometric Login", value: "BiometricLogin" },
];
const EmployeeLoginDetails = () => {
  const {
    register,
    formState: { errors },
    watch,
    setValue,
    setError,
    clearErrors,
    trigger,
  } = useFormContext();

  const { mutate: userValidation } = useEmpUserNameValidationMutation();
  const checkUserValidation = async () => {
    const payload = {
      companyCode: watch("companyCode"),
      email: watch("employeeLogin[0].userName"),
    };
    userValidation(payload, {
      onSuccess: (data) => {
        if (data?.response) {
          clearErrors("employeeLogin[0].userName");
        } else {
          setError("employeeLogin[0].userName", {
            type: "custom",
            message: data?.errorMessage || "User Name already taken",
          });
        }
      },
    });
    // const userValidation2 = await refetch();

    // if (userValidation2?.response) {
    //   clearErrors("employeeLogin[0].userName");
    // } else {
    //   setError("employeeLogin[0].userName", {
    //     type: "custom",
    //     message:
    //       userValidation2?.data?.errorMessage || "User Name already taken",
    //   });
    // }
  };
  const [showPassword, setShowPassword] = useState(false);
  return (
    <>
      <div className="addproduct-icon list icon">
        <h5>
          <Info className="add-info" />
          <span>Login Details</span>
        </h5>
      </div>
      <div className="form-row row">
        <div className="col-md-4 mb-3">
          <div className="form-floating">
            <input
              id="employeeLogin[0].userName"
              {...register("employeeLogin[0].userName", { required: true })} //name="employeeLogin[0].userName"
              type="text"
              placeholder="User Name"
              className={`form-control ${
                errors.employeeLogin?.[0]?.userName ? "is-invalid" : ""
              }`}
              // onChange={checkUserValidation}
            />
            <label htmlFor="employeeLogin[0].userName" className="form-label">
              User Name<span className="asterisk">*</span>
            </label>
            {errors.employeeLogin?.[0]?.userName ? (
              <div className="invalid-feedback">
                {errors.employeeLogin?.[0]?.userName?.message}
              </div>
            ) : (
              <div className="valid-feedback">User Name is valid</div>
            )}
          </div>
        </div>

        <div className="col-md-4 mb-3">
          <div className="input-group">
            <Input
              name={`employeeLogin[0].password`}
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className={`form-control ${
                errors.employeeLogin?.[0]?.password ? "is-invalid" : ""
              }`}
              label="Password"
              labelClassName="form-label"
              required={true}
              requiredMessage="Password is required"
            />
            <span
              className="input-group-text"
              id="basic-addon1"
              style={{ border: "none" }}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff size={14} /> : <Eye size={14} />}
            </span>
          </div>
        </div>

        {/* <div className="col-md-4 mb-3">
          <Input
            name={`employeeLogin[0].loginAttempts`}
            type="loginAttempts"
            placeholder="Max Login Attempts"
            className={`form-control ${
              errors.employeeLogin?.[0]?.loginAttempts ? "is-invalid" : ""
            }`}
            label="Max Login Attempts"
            labelClassName="form-label"
            required={true}
            requiredMessage="Max Login Attempts is required"
          />
        </div> */}

        <div className="col-md-4 mb-3">
          <Input
            name={`employeeLogin[0].userType`}
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.employeeLogin?.[0]?.userType ? "is-invalid" : ""
            }`}
            label="User Type"
            labelClassName="form-label"
            optionData={userType}
            required={true}
            requiredMessage="User Type is required"
            onChange={(selectedOption) => {
              setValue("employeeLogin[0].userType", selectedOption);
              trigger("employeeLogin[0].userType");
            }}
            defaultValue={watch("employeeLogin[0].userType")}
          />
        </div>

        <div className="col-md-4 mb-3">
          <Input
            name={`employeeLogin[0].loginType`}
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.employeeLogin?.[0]?.loginType ? "is-invalid" : ""
            }`}
            label="Login Type"
            labelClassName="form-label"
            optionData={loginTypeOptions}
            required={true}
            requiredMessage="Login Type is required"
            // onChange={(selectedOption) => {
            //   setValue("employeeLogin[0].loginType", selectedOption);
            //   trigger("employeeLogin[0].loginType");
            // }}
            onChange={(selectedOptions) => {
              console.log(selectedOptions);
              setValue(
                "employeeLogin[0].loginType",
                Array.isArray(selectedOptions)
                  ? selectedOptions.map((option) => option)
                  : [],
              );
            }}
            defaultValue={watch("employeeLogin[0].loginType")}
            //  value={
            //   Array.isArray(watch("employeeLogin[0].loginType")) &&
            //   watch("employeeLogin[0].loginType").some((v) => v !== "NULL")
            //     ? watch("employeeLogin[0].loginType").filter((v) => v !== "NULL")
            //     : []
            // }
            mode="multiple"
            allowClear
            showSearch
            style={{ width: "100%", height: "auto" }}
          />
        </div>

        {/* <div className="col-md-4 mb-3">
          <Input
            name={`employeeLogin[0].isLock`}
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.employeeLogin?.[0]?.isLock ? "is-invalid" : ""
            }`}
            label="User Locked ?"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="User Locked is required"
            onChange={(selectedOption) => {
              setValue("employeeLogin[0].isLock", selectedOption);
              trigger("employeeLogin[0].isLock");
            }}
            defaultValue={watch("employeeLogin[0].isLock")}
          />
        </div> */}

        <div className="col-md-4 mb-3">
          <Input
            name={`employeeLogin[0].isActive`}
            type="commonSelect"
            placeholder=""
            className={`form-control ${
              errors.employeeLogin?.[0]?.isActive ? "is-invalid" : ""
            }`}
            label="Actice Status"
            labelClassName="form-label"
            optionData={activestatus}
            required={true}
            requiredMessage="Active Status is required"
            onChange={(selectedOption) => {
              setValue("employeeLogin[0].isActive", selectedOption);
              trigger("employeeLogin[0].isActive");
            }}
            defaultValue={watch("employeeLogin[0].isActive")}
          />
        </div>
      </div>
    </>
  );
};

export default EmployeeLoginDetails;
